const style = theme => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  pageTitle: {
    color: '#002E47',
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '36px',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  cardHeader: {
    color: '#002E47',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '36px',
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: '#CBD0D7',
  },
  personalRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  avatar: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#015FFB',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    lineHeight: '24px',
    fontWeight: 600,
    textTransform: 'uppercase',
    flexShrink: 0,
  },
  userInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  userName: {
    color: '#002E47',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  userEmail: {
    color: '#919EAB',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '36px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  personalCta: {
    minWidth: 177,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  detailsCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  detailsHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      rowGap: 0,
    },
  },
  seePlansButton: {
    display: 'inline-block',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '24px',
    marginLeft: 'auto',
    color: '#015FFB',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  trialBanner: {
    backgroundColor: '#FFF2D6',
    borderRadius: 8,
    width: '100%',
    height: 56,
    opacity: 1,
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: 56,
      padding: 12,
      alignItems: 'flex-start',
    },
  },
  trialBannerText: {
    color: '#002E47',
    fontSize: 15,
    fontWeight: 400,
    lineHeight: '150%',
  },
  trialBannerButton: {
    flexShrink: 0,
    width: 116,
    height: 32,
    minWidth: 116,
    opacity: 1,
    '& .MuiButton-label': {
      gap: 8,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },
  usage: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingTop: 10,
    borderTop: '1px solid #F1F3F5',
  },
  usageHead: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: 'Inter',
    fontSize: 12,
    color: '#637381',
  },
  usageTrack: {
    height: 6,
    borderRadius: 999,
    background: '#E5E7EB',
    overflow: 'hidden',
  },
  usageFill: {
    height: '100%',
    borderRadius: 999,
    background: '#015FFB',
  },
  leftLabel: {
    color: '#637381',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '36px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  rightValue: {
    color: '#002E47',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '36px',
    textAlign: 'right',
  },
  infoIconButton: {
    padding: 0,
    minWidth: 20,
    width: 20,
    height: 20,
    borderRadius: 10,
    color: '#015FFB',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  modalPaper: {
    width: 'min(964px, calc(100vw - 32px))',
    maxWidth: 964,
    borderRadius: 12,
    boxShadow: '0px 12px 48px 0px rgba(145, 158, 171, 0.48)',
    padding: 0,
  },
  modalContent: {
    padding: '24px 24px 0 24px !important',
  },
  modalTitle: {
    color: '#002E47',
    fontFamily: 'Be Vietnam',
    fontStyle: 'normal',
    fontSize: 15,
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: 0,
    marginBottom: 12,
  },
  modalBody: {
    color: '#002E47',
    fontFamily: 'Be Vietnam',
    fontStyle: 'normal',
    fontSize: 15,
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: 0,
  },
  modalList: {
    marginTop: 12,
    marginBottom: 12,
    paddingLeft: 20,
  },
  modalActions: {
    padding: '8px 24px 24px !important',
    marginTop: 0,
    minHeight: 'auto',
    borderTop: 'none',
    justifyContent: 'flex-end',
  },
  loading: {
    marginTop: 12,
  },
})

export default style
